import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { createBlog, updateBlog, getBlog } from "./api";
import RichTextEditor from "./RichTextEditor";
import styles from "./Form.module.css";

export default function BlogsAdd() {
  const navigate = useNavigate();
  const [title, setTitle] = useState("");
  const [content, setContent] = useState("");
  const [image, setImage] = useState(null);
  const [status, setStatus] = useState("");
  const [editId, setEditId] = useState(null);

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const id = params.get('id');
    if (id) {
      setEditId(id);
      getBlog(id).then((res)=>{
        if (res.item) {
          setTitle(res.item.title || "");
          setContent(res.item.content || "");
        }
      }).catch(()=>{});
    }
  }, []);

  async function onSubmit(e) {
    e.preventDefault();
    setStatus("");
    const plainText = content.replace(/<[^>]*>/g, "").trim();
    if (!plainText) {
      setStatus("Content is required");
      return;
    }

    const fd = new FormData();
    fd.append("title", title);
    fd.append("content", content);
    if (image) fd.append("image", image);
    try {
      if (editId) {
        await updateBlog(editId, fd);
      } else {
        await createBlog(fd);
      }
      navigate("/admin/blogs");
    } catch (err) {
      setStatus(err.message || "Failed");
    }
  }

  return (
    <div className={styles.card}>
      <h2 className={styles.title}>Add Blog</h2>
      {status && <p>{status}</p>}
      <form className={styles.grid} onSubmit={onSubmit}>
        <div className={styles.row}>
          <div className={styles.label}>Blog Title</div>
          <input className={styles.input} placeholder="Enter Blog Title" value={title} onChange={(e) => setTitle(e.target.value)} required />
        </div>
        <div className={styles.row}>
          <div className={styles.label}>Content</div>
          <div className={styles.editorField}>
            <RichTextEditor value={content} onChange={setContent} placeholder="Write blog content here..." />
          </div>
        </div>
        <div className={styles.row}>
          <div className={styles.label}>Upload Image (Optional)</div>
          <input className={styles.file} type="file" accept="image/*" onChange={(e) => setImage(e.target.files?.[0] || null)} />
        </div>
        <div className={styles.actions}>
          <button className={styles.button} type="submit">Submit</button>
        </div>
      </form>
    </div>
  );
}


